import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared';

const routes: Routes = [
    {
        path: '',
        loadChildren: './layout/layout.module#LayoutModule',
        canActivate: [AuthGuard]
    },
    { path: '', loadChildren: './customer/customer.module#CustomerModule' },
    { path: 'login', loadChildren: './login/login.module#LoginModule' },
    { path: 'customer', loadChildren: './customer/customerlogin/customerlogin.module#CustomerLoginModule' } ,
   // { path: 'import', loadChildren: './customer/customer-dashboard/csv-importer.module#CsvImporterModule' },    
    { path: 'signup', loadChildren: './signup/signup.module#SignupModule' },
    { path: 'not-found', loadChildren: './not-found/not-found.module#NotFoundModule' },
    { path: 'downloads', loadChildren: './downloads/downloads.module#DownloadsModule' },
    { path: 'eula', loadChildren: './downloads/eula/eula.module#EulaModule'  },
    { path: 'legal', loadChildren: './downloads/legal/legal.module#LegalModule' },
    { path: '**', redirectTo: 'not-found' } 
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/bishop.duperret.GOMURAL/Documents/ConciergeDashboard/gomural-mural-outlook-configuration-dashboard-43c2b5785cd3/src/app/app-routing.module.ts